<template>
    <div v-if="href" class="border-t border-gray-100 hover:bg-gray-100 focus-within:bg-gray-100">
        <a v-if="basicLink" class="px-6 py-4 flex items-center focus:text-indigo-500" :href="href">
            <slot></slot>
            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400 ml-auto"/>
        </a>
        <inertia-link v-else class="px-6 py-4 flex items-center focus:text-indigo-500" :href="href">
            <slot></slot>
            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400 ml-auto"/>
        </inertia-link>
    </div>
    <div v-else-if="button" class="border-t border-gray-100 hover:bg-gray-100 focus-within:bg-gray-100">
        <button v-on:click="$emit('click')" class="w-full px-6 py-4 flex items-center focus:text-indigo-500">
            <slot></slot>
            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400 ml-auto"/>
        </button>
    </div>
    <div v-else class="border-t border-gray-100">
        <div class="px-6 py-4 flex items-center">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import Icon from "@/Shared/Icon";

export default {
    props: {
        href: String,
        basicLink: Boolean,
        button: Boolean,
    },
    components: {
        Icon,
    },
}
</script>
